export const coverageIssueSelection = (row, issue, typeNos = null) => ({
  typeNos: typeNos?.length ? typeNos.map(String) : [String(row.type_no)],
  engineCode: "",
  // Coverage snapshots keep stable catalogue keys for persistence and expose
  // the current administrator labels separately. The picker and inspect API
  // work with those display labels.
  category: issue.category_label || issue.category,
  subcategory: issue.subcategory_label || issue.subcategory || "",
  detail: issue.detail_label || issue.detail || "",
  label: `${row.brand} · ${row.model} · ${row.model_body || row.vehicle_type} · Tip ${row.type_no}`,
});

export const mergeVehicleCoverageRows = (payloads, typeNo) => {
  const type = String(typeNo || "").trim();
  if (!type) return null;
  const rows = (payloads || []).flatMap((payload) => payload?.items || [])
    .filter((row) => String(row.type_no) === type);
  if (!rows.length) return null;
  const issues = new Map();
  rows.forEach((row) => (row.issues || []).forEach((issue) => {
    const key = [issue.category || "", issue.subcategory || "", issue.detail || ""].join("\u001f");
    if (!issues.has(key)) issues.set(key, issue);
  }));
  const sortedIssues = [...issues.values()].sort((left, right) =>
    [left.category_label || left.category || "", left.subcategory_label || left.subcategory || "", left.detail_label || left.detail || ""].join("\u001f")
      .localeCompare([right.category_label || right.category || "", right.subcategory_label || right.subcategory || "", right.detail_label || right.detail || ""].join("\u001f"), "tr"));
  return sortedIssues.length ? { ...rows[0], issues: sortedIssues, issue_count: sortedIssues.length } : null;
};

export const noOemDecisionSummary = (inspection) => {
  const decisions = inspection?.no_oem_decisions || [];
  return {
    decisions,
    isNotApplicable: inspection?.decision_state === "not_applicable",
    isMixed: inspection?.decision_state === "mixed",
  };
};
